<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card class="content-modal" :class="styleModal">
      <v-card-text>{{text}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="deleteWin">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "mmessagedialog",
  props: ["value", "text", "styleModal"],
  data() {
    return {
      dialog: false
    };
  },
  mounted() {},
  watch: {
    value: function(val) {
      this.dialog = val;
    }
  },
  components: {},
  methods: {
    deleteWin() {
      this.$emit("closeModal");
    }
  }
};
</script>
<style scoped>
.content-modal {
  font-size: 18px !important;
}
.ok {
  background-color: #bafbb9;
}
.attention {
  background-color: #eaea94;
}
.notok {
  background-color: #ffb8b4;
}
</style>

